export default __webpack_public_path__ + "static/media/Patrimoine-industriel.8377a486.svg";